import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { panelPath } from '../config/paths';

export function useIsPro(): {
  isPro: boolean;
  goToUpgrade: () => void;
} {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isPro = user?.canUseAI === true;
  const goToUpgrade = useCallback(() => {
    navigate(panelPath('upgrade'));
  }, [navigate]);
  return { isPro, goToUpgrade };
}
